import { render, staticRenderFns } from "./Testimonials.vue?vue&type=template&id=245f25aa&scoped=true"
import script from "./Testimonials.js?vue&type=script&lang=js&external"
export * from "./Testimonials.js?vue&type=script&lang=js&external"
import style0 from "./Testimonials.scss?vue&type=style&index=0&id=245f25aa&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "245f25aa",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HotTitle: require('/home/runner/_work/app-hotmart-digital-learning/app-hotmart-digital-learning/components/Atoms/Title/Title.vue').default,HotCarousel: require('/home/runner/_work/app-hotmart-digital-learning/app-hotmart-digital-learning/components/Molecules/Carousel/Carousel.vue').default,HotButton: require('/home/runner/_work/app-hotmart-digital-learning/app-hotmart-digital-learning/components/Atoms/Button/Button.vue').default})
